import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsPopoverCss = ":host{--sizing-max-width-default:352px;display:inline-block}:host [popover]{background-color:var(--pine-color-background-container);border:var(--pine-border);border-radius:var(--pine-dimension-125);-webkit-box-shadow:var(--pine-box-shadow-200);box-shadow:var(--pine-box-shadow-200);margin:var(--pine-dimension-none);max-width:var(--sizing-max-width-default);padding:var(--pine-dimension-md);position:fixed}:host button{-ms-flex-align:center;align-items:center;background-color:var(--pine-color-secondary);border:var(--pine-border);border-radius:var(--pine-border-radius-full);color:var(--pine-color-text-secondary);display:-ms-flexbox;display:flex;font:var(--pine-typography-body-medium);font-family:var(--pine-font-family-heading);letter-spacing:var(--pine-letter-spacing);min-height:40px;padding:var(--pine-dimension-xs) var(--pine-dimension-sm)}:host button:focus-visible{outline:var(--pine-outline-focus);outline-offset:var(--pine-border-width)}:host button:hover{background-color:var(--pine-color-secondary-hover)}";

const PdsPopover$1 = /*@__PURE__*/ proxyCustomElement(class PdsPopover extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Determines when the popover is active
         * @defaultValue false
         */
        this.active = false;
        /**
         * Determines the action that triggers the popover. For manual popovers, the consumer is responsible for toggling this value.
         * @defaultValue "show"
         */
        this.popoverTargetAction = 'show';
        /**
         * Determines the type of popover. Auto popovers can be "light dismissed" by clicking outside of the popover.
         * Manual popovers require the consumer to handle the visibility of the popover.
         */
        this.popoverType = 'auto';
        /**
         * Sets the maximum width of the popover content
         * @defaultValue 352
         */
        this.maxWidth = 352;
        /**
         * Determines the preferred position of the popover
         * @defaultValue "right"
         */
        this.placement = 'right';
    }
    componentWillRender() {
        this.handlePopoverPositioning();
    }
    handleClick() {
        this.active = !this.active;
    }
    handleScroll() {
        if (this.active) {
            this.handlePopoverPositioning();
        }
    }
    handlePopoverPositioning() {
        const triggerEl = this.el.shadowRoot.querySelector('.pds-popover__trigger');
        const popoverEl = this.el.shadowRoot.querySelector('div[popover]');
        if (!triggerEl || !popoverEl)
            return;
        const triggerRect = triggerEl.getBoundingClientRect();
        const popoverRect = popoverEl.getBoundingClientRect();
        let top = 0;
        let left = 0;
        const offset = 8;
        switch (this.placement) {
            case 'top':
                top = triggerRect.top - popoverRect.height - offset;
                left = triggerRect.left + (triggerRect.width - popoverRect.width) / 2;
                break;
            case 'top-start':
                top = triggerRect.top - popoverRect.height - offset;
                left = triggerRect.left;
                break;
            case 'top-end':
                top = triggerRect.top - popoverRect.height - offset;
                left = triggerRect.right - popoverRect.width;
                break;
            case 'right':
                top = triggerRect.top + (triggerRect.height - popoverRect.height) / 2;
                left = triggerRect.right + offset;
                break;
            case 'right-start':
                top = triggerRect.top;
                left = triggerRect.right + offset;
                break;
            case 'right-end':
                top = triggerRect.bottom - popoverRect.height;
                left = triggerRect.right + offset;
                break;
            case 'bottom':
                top = triggerRect.bottom + offset;
                left = triggerRect.left + (triggerRect.width - popoverRect.width) / 2;
                break;
            case 'bottom-start':
                top = triggerRect.bottom + offset;
                left = triggerRect.left;
                break;
            case 'bottom-end':
                top = triggerRect.bottom + offset;
                left = triggerRect.right - popoverRect.width;
                break;
            case 'left':
                top = triggerRect.top + (triggerRect.height - popoverRect.height) / 2;
                left = triggerRect.left - popoverRect.width - offset;
                break;
            case 'left-start':
                top = triggerRect.top;
                left = triggerRect.left - popoverRect.width - offset;
                break;
            case 'left-end':
                top = triggerRect.bottom - popoverRect.height;
                left = triggerRect.left - popoverRect.width - offset;
                break;
        }
        popoverEl.style.top = `${top}px`;
        popoverEl.style.left = `${left}px`;
    }
    render() {
        return (h(Host, { key: 'b150645b71d528055c6cd6cf2ff9c898c3fe1f3f' }, h("button", { key: '3090efe8ffd85d0d3e4d5dc5f54147a5aff61fb9', class: "pds-popover__trigger", popoverTarget: this.componentId, popoverTargetAction: this.popoverTargetAction, onClick: this.handleClick }, this.text), h("div", { key: '6e9b4af0278507b6f8bf4b5f2d8c3a2891f974b6', class: `pds-popover ${this.active ? 'pds-popover--active' : ''}`, id: this.componentId, popover: this.popoverType, style: { maxWidth: `${this.maxWidth}px` } }, h("slot", { key: 'f4303d3f3aca19314413b86d3973c8d9f1477e8f' }))));
    }
    get el() { return this; }
    static get style() { return pdsPopoverCss; }
}, [1, "pds-popover", {
        "popoverTargetAction": [1, "popover-target-action"],
        "popoverType": [1, "popover-type"],
        "componentId": [1, "component-id"],
        "text": [1],
        "maxWidth": [2, "max-width"],
        "placement": [513],
        "active": [32]
    }, [[2, "click", "handleClick"], [11, "scroll", "handleScroll"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-popover"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-popover":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsPopover$1);
            }
            break;
    } });
}

const PdsPopover = PdsPopover$1;
const defineCustomElement = defineCustomElement$1;

export { PdsPopover, defineCustomElement };
//# sourceMappingURL=pds-popover.js.map

//# sourceMappingURL=pds-popover.js.map